"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacySingleSelectList = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var pick_1 = tslib_1.__importDefault(require("lodash/pick"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var LegacyList_1 = require("./LegacyList");
var LegacyListItem_1 = require("./LegacyListItem");
var LegacySingleSelectListItem_1 = require("./LegacySingleSelectListItem");
var guid_1 = require("./guid");
/**
 * @internal
 * @deprecated This component is deprecated use SingleSelectList instead
 */
var LegacySingleSelectList = /** @class */ (function (_super) {
    tslib_1.__extends(LegacySingleSelectList, _super);
    function LegacySingleSelectList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegacySingleSelectList.prototype.getSelectableItems = function () {
        var props = this.props;
        return props.items.map(function (source) { return ({
            source: source,
            onSelect: props.onSelect,
            onMouseOver: props.onItemMouseOver,
            onMouseOut: props.onItemMouseOut,
            onMouseEnter: props.onItemMouseEnter,
            onMouseLeave: props.onItemMouseLeave,
            selected: source === props.selection,
            id: props.getItemKey(source),
        }); });
    };
    LegacySingleSelectList.prototype.getClassNames = function () {
        return classnames_1.default("gd-list", this.props.className);
    };
    LegacySingleSelectList.prototype.getRowItem = function () {
        var _a = this.props, rowItem = _a.rowItem, listItemClass = _a.listItemClass;
        return rowItem || react_1.default.createElement(LegacyListItem_1.LegacyListItem, { listItemClass: listItemClass });
    };
    LegacySingleSelectList.prototype.getDataSource = function () {
        var selectableItems = this.getSelectableItems();
        return {
            rowsCount: this.props.itemsCount || selectableItems.length,
            getObjectAt: function (rowIndex) { return selectableItems[rowIndex]; },
        };
    };
    LegacySingleSelectList.prototype.render = function () {
        var rowItem = this.getRowItem();
        var dataSource = this.getDataSource();
        return (react_1.default.createElement(LegacyList_1.LegacyList, tslib_1.__assign({ className: this.getClassNames() }, pick_1.default(this.props, ["width", "height", "itemHeight"]), { dataSource: dataSource, rowItem: rowItem, onScroll: this.props.onRangeChange, onScrollStart: this.props.onScrollStart, scrollToSelected: this.props.scrollToSelected })));
    };
    LegacySingleSelectList.defaultProps = {
        className: "",
        getItemKey: guid_1.guidFor,
        items: [],
        itemsCount: 0,
        listItemClass: LegacySingleSelectListItem_1.LegacySingleSelectListItem,
        onItemMouseOut: noop_1.default,
        onItemMouseOver: noop_1.default,
        onItemMouseEnter: noop_1.default,
        onItemMouseLeave: noop_1.default,
        onRangeChange: noop_1.default,
        onScrollStart: noop_1.default,
        onSelect: noop_1.default,
        rowItem: null,
        scrollToSelected: false,
        selection: {},
    };
    return LegacySingleSelectList;
}(react_1.Component));
exports.LegacySingleSelectList = LegacySingleSelectList;
//# sourceMappingURL=LegacySingleSelectList.js.map